export const CLIENTS = [
  {
    id: 1,
    name: "John Smith",
    email: "john.smith@example.com",
    phone: "+1 555 234 5678",
    status: "Active",
    address: {
      line1: "123 Business Park",
      city: "Bangalore",
      country: "India"
    }
  },
  {
    id: 2,
    name: "Emily Johnson",
    email: "emily.j@example.com",
    phone: "+1 555 987 1122",
    status: "Inactive",
    address: {
      line1: "456 Tech Hub",
      city: "Mumbai",
      country: "India"
    }
  },
  {
    id: 3,
    name: "Michael Brown",
    email: "michael.brown@example.com",
    phone: "+1 555 772 4433",
    status: "Active",
    address: {
      line1: "789 Corporate Tower",
      city: "Delhi",
      country: "India"
    }
  },
  {
    id: 4,
    name: "Olivia Lee",
    email: "olivia.lee@example.com",
    phone: "+1 555 123 4567",
    status: "Active",
    address: {
      line1: "321 Innovation Center",
      city: "Pune",
      country: "India"
    }
  },
  {
    id: 5,
    name: "Ethan Hall",
    email: "ethan.hall@example.com",
    phone: "+1 555 901 2345",
    status: "Inactive",
    address: {
      line1: "654 Business Plaza",
      city: "Chennai",
      country: "India"
    }
  },
  {
    id: 6,
    name: "Sophia Patel",
    email: "sophia.patel@example.com",
    phone: "+1 555 678 9012",
    status: "Active",
    address: {
      line1: "987 Enterprise Park",
      city: "Hyderabad",
      country: "India"
    }
  },
  {
    id: 7,
    name: "Liam Chen",
    email: "liam.chen@example.com",
    phone: "+1 555 345 6789",
    status: "Inactive",
    address: {
      line1: "147 Commerce Hub",
      city: "Kolkata",
      country: "India"
    }
  },
  {
    id: 8,
    name: "Alexander Martin",
    email: "alexander.martin@example.com",
    phone: "+1 555 567 8901",
    status: "Active",
    address: {
      line1: "258 Trade Center",
      city: "Ahmedabad",
      country: "India"
    }
  },
  {
    id: 9,
    name: "Ruby Singh",
    email: "ruby.singh@example.com",
    phone: "+1 555 890 1234",
    status: "Inactive",
    address: {
      line1: "369 Office Complex",
      city: "Jaipur",
      country: "India"
    }
  },
  {
    id: 10,
    name: "Hannah Lee",
    email: "hannah.lee@example.com",
    phone: "+1 555 111 2223",
    status: "Active",
    address: {
      line1: "741 Business District",
      city: "Lucknow",
      country: "India"
    }
  }
];
